module.exports = __webpack_public_path__ + "media/images/peb/20px/peb_g-9994e7dff0ee28970e967e75a9b998b0.png";